<script>
import ElCalendar from 'element-ui/packages/calendar/src/main'

export default {
  // 保留现有归档页 ref.date、模型和导航方法，以及 dateCell 作用域插槽。
  name: 'ElCalendar',
  extends: ElCalendar,
  render (h) {
    const vnode = ElCalendar.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-calendar']
    return vnode
  }
}
</script>
